<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-sort
    v-model="selectedItemIds"
    data-url="admin/rbu/managing_rbu/"
    :extra-params="{ account_id: accountId }"
    data-key="rbus"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    :total-item-count.sync="totalItemCount"
    hide-default-footer
    class="admin-volume-list"
  >
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn
          text
          color="primary"
          v-if="canDeleteItem(item)"
          @click="deleteItem(item)"
        >
          REMOVE
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList.vue";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";
import { USER_TYPE } from "@/constants";

export default {
  name: "AdminManagingRbuList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
    accountId: String,
  },
  setup(props, { root, emit }) {
    const me = computed(() => root.$me());
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      {
        text: "RBU Edition",
        value: "edition.edition",
        width: 150,
      },
      { text: "RBU Edition Name", value: "edition.name" },
      { text: "Volume Name", value: "name" },
      { text: "", value: "actions", sortable: false, width: 250 },
    ]);
    const innerRefreshTrigger = ref(false);
    const selectedItemIds = ref([]);
    const totalItemCount = ref(0);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const canDeleteItem = function (item) {
      return (
        [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].indexOf(me.value.type) !== -1
      );
    };

    const deleteItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: "Remove Rbu Volume Admin Permission?",
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/volume/admin_remove/",
          params: { volume_id: item.id, account_id: props.accountId },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,
      totalItemCount,

      canDeleteItem,
      deleteItem,
    };
  },
};
</script>

<style lang="less">
.admin-volume-list {
  .admin-status-span {
    .admin-status-dot {
      height: 10px;
      width: 10px;
      border-radius: 10px;
      display: inline-block;
    }

    &.DECLINED {
      color: #ef3924;

      .admin-status-dot {
        background-color: #ef3924;
      }
    }

    &.PENDING {
      color: #d4a106;

      .admin-status-dot {
        background-color: #d4a106;
      }
    }

    &.APPROVED {
      color: #5bc23f;

      .admin-status-dot {
        background-color: #5bc23f;
      }
    }
  }
}
</style>
